import { render, staticRenderFns } from "./answer-sheet.vue?vue&type=template&id=f3dea49c&"
import script from "./answer-sheet.vue?vue&type=script&lang=js&"
export * from "./answer-sheet.vue?vue&type=script&lang=js&"
import style0 from "./answer-sheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports